module.exports = __webpack_public_path__ + "img/information-logo.svg";